<template>
  <section class="hero-branding bg-cover" :style="bgImg" id="home">
    <div class="container-fluid container-fluid--cp-150">
      <div class="row hero-startup">
        <div class="col-xl-6 text-center text-xl-left">
          <div class="hero-content mx-auto">
            <h2 class="hero-content-title">
              以資訊科技 <br />
              為您的企業帶來新的面貌
            </h2>
            <h6 class="hero-content-subtitle mt-20">
              資訊科技的優勢成為了各行各業爭奪的領域。我們可提供各類訂製科技方案，包括網頁製作、手機應用程式開發等服務，助您的企業升級，領先行頭。
            </h6>
            <div class="slider-button mt-30">
              <a href="mailto:info@cyberfire.com.hk" class="ht-btn ht-btn-md"
                >取得報價</a
              >
              <!-- <h6 class="sub-heading">
                Questions?
                <router-link to="" class="hover-style-link text-custom"
                  >取得報價</router-link
                >
              </h6> -->
            </div>
          </div>
        </div>
        <div class="col-md-6 align-self-end d-md-none d-xl-block">
          <div class="startup-thumb">
            <img
              src="../../assets/img/hero/startup/startup-thumb.png"
              class="img-fluid"
              alt="startup-thumb"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      bgImg: {
        backgroundImage: `url(${require("../../assets/img/hero/ebook/ebook-hero-bg.jpg")})`,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variabls.scss";
@import "../../assets/scss/elements/hero-branding.scss";

.hero-branding {
  // responsive
  @media #{$large-mobile} {
    height: 950px;
  }
}
.hero-startup {
  align-items: center;
  display: flex;
  height: 100vh;
  .startup-thumb {
    bottom: -32px;
    position: relative;
    z-index: 1;
    // responsive
    @media #{$tablet-device} {
      bottom: -15px;
    }
  }
}
.hero-content {
  // responsive
  @media #{$tablet-device} {
    width: 100%;
  }
  //   &-title,
  //   &-subtitle {
  //     color: $white;
  //   }
  .slider-button {
    display: flex;
    align-items: center;
    // responsive
    @media #{$tablet-device, $extra-small-mobile} {
      display: block;
    }
  }
  .sub-heading {
    font-size: 15px;
    // color: $white;
    padding-left: 20px;
    // responsive
    @media #{$tablet-device, $extra-small-mobile} {
      padding-left: 0;
      padding-top: 15px;
    }
  }
  &-title {
    font-weight: 600;
  }
}

.text-custom {
  color: #7c82fe;
}
</style>
